(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.faq = {
    attach: function (context, settings) {
      $(".itemAccordion label").on("click", function () {
        $(this).parent().toggleClass('open');
        if ($(this).parent().hasClass('open')) {
          var hBlock = $(this).parent().find(".itemAccordionContent_inner").outerHeight();
          $(this).parent().find(".itemAccordionContent").css("max-height", hBlock);
        } else {
          $(this).parent().find(".itemAccordionContent").css("max-height", "0");
        }
      });
    }
  }
})(jQuery, Drupal, drupalSettings);
